/*
 * @Descripttion: 
 * @version: 
 * @Author: bbq
 * @Date: 2020-08-17 09:56:40
 * @LastEditors: bbqin
 * @LastEditTime: 2021-09-02 18:59:00
 */
import React, { Component } from 'react';
import classnames from 'classnames';
import Tooltip from '../Tooltip';
import { getMultiLang } from '@platform/api';

require('./index.less');

export default class MaxZoomBtn extends Component {
    constructor(props) {
        super(props);
        this.state = { langJson: {}, max: props.max };
    }

    UNSAFE_componentWillMount() {
        let callback = langJson => {
            this.setState({ langJson });
        };
        // moduleId为所需加载langJson文件夹名称前缀
        getMultiLang({ moduleId: 'common_icon_title', callback });
    }

    render() {
        let { langJson } = this.state;
        let { onClick, className = '', tooltip = langJson['icon-max-zoom'], disabled = false, ...others } = this.props;
        let maxZoomClass = classnames({
            'max-zoom-btn-disabled': disabled,
            'max-zoom-btn iconfont icon icon-zuidahua': !this.state.max,
            'max-zoom-btn iconfont icon icon-zuixiaohua': this.state.max,
        });
        return (
            <Tooltip
                placement="top"
                overlay={this.state.max ? langJson['icon-reset-zoom'] : langJson['icon-max-zoom']}
                delayHide={1}
                delayShow={1000}
            >
                <span
                    className={className ? className + ' ' + maxZoomClass : maxZoomClass}
                    onClick={e => {
                        if (!disabled) {
                            this.setState({ max: !this.state.max }, () => {
                                if (onClick && typeof onClick === "function") {
                                    onClick(this.state.max, e);
                                }
                            })

                        }
                    }}
                    {...others}
                ></span>
            </Tooltip>
        );
    }

}